/**
 * Main application layout - now uses DashboardLayout for authenticated users
 */

import { DashboardLayout } from '@/layouts/DashboardLayout';
import { CommandPalette } from '@/components/command/CommandPalette';
import { useGlobalKeyboardShortcuts } from '@/hooks/useKeyboardShortcuts';

export function AppLayout() {
  // Initialize global keyboard shortcuts
  useGlobalKeyboardShortcuts();

  // The DashboardLayout handles all authenticated views
  // For unauthenticated views, we would render a different layout
  return (
    <>
      <DashboardLayout />
      <CommandPalette />
    </>
  );
}
